import React, { useEffect, useMemo, useState } from 'react';
import { useSnackbar } from '../../components/KenSnackbar';
import { Box, Button, Chip, Dialog, DialogContent, DialogTitle, Divider, Grid, MenuItem, Paper, Select, SelectChangeEvent, Typography, useTheme, Skeleton } from '@mui/material';
import { makeStyles } from "@mui/styles";
import Header from '../../components/navigation/Header';
import semesterImage from '../../assets/Result/Frame.png';
import semesterImagemobile from '../../assets/MainLayout/cloudmobile.png';

import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { IconButton } from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  CartesianGrid,
} from "recharts";
import KenTable from '../../components/KenTable';
import { useNavigate } from 'react-router-dom';
import NetworkAnalysis from '../networkAnalysis';
import CloseIcon from '@mui/icons-material/Close';
import { useMediaQuery } from "@mui/material";
import { getMarksBreakdown } from '../../utils/apiService';




const useStyles = makeStyles(() => ({
  header: {
    fontSize: '18px',
    fontWeight: '500',
  },
  // container: {
  //   borderRadius: '8px',
  //   marginTop: '32px',
  //   // minHeight: 'calc(100vh - 120px)',
  //   position: 'relative',
  // },
  container: {
    borderRadius: '8px',
    // background: '#ffffff',
    marginTop: '32px',
    // height: 'calc(100vh - 165px)',
    width: '100%',
    height : 'calc(100vh - 155px)'

    // position: 'relative',
    // padding : '12px',
    // overflow: 'auto'
  },
  containermobile: {
    borderRadius: '8px',
    marginTop: '32px',
    width: '100%',
    height: '100vh',

  }
}));

const Dashboard = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const classes = useStyles();
  const navigate = useNavigate();
  const { showSnackbar } = useSnackbar();
  const [age, setAge] = React.useState(10);
  const [open, setOpen] = React.useState(false);
  const [selectedRow, setSelectedRow] = React.useState<any>(null);
  const [tableData, setTableData] = React.useState<any[]>([]);
  const [activeSemester, setActiveSemester] = useState(1);
  const [selection, setSelection] = useState<any>([]);
  const [semestersData, setSemestersData] = useState<any[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const handleChange = (event: SelectChangeEvent<number>) => {

    console.log(event.target.value, "sjfnsfdkj");

    setActiveSemester(Number(event.target.value));

    // selection.filter((item: any) => item.Semester === event.target.value)
  };
  useEffect(() => {
    setLoading(true);
    getMarksBreakdown().then((res) => {
      const response = Array.isArray(res?.data) ? res?.data : [];

      const sortedResponse = [...response].sort(
        (a: any, b: any) => Number(a?.Semester ?? 0) - Number(b?.Semester ?? 0)
      );

      const semesters = sortedResponse.map((item: any, index: number) => {
        const courses = (item?.Courses || []).map((course: any, idx: number) => {
          const creditsEarnedValue = Number(course?.CreditsEarned);
          const hasCreditsEarned = Number.isFinite(creditsEarnedValue);
          return {
          id: course?.id || `${item?.Semester || index + 1}-${idx}`,
          courseName: course?.CourseName,
          courseCode: course?.CourseCode,
          credits: Number(course?.Credits) || 0,
          creditsEarned: hasCreditsEarned ? creditsEarnedValue : "-",
          creditsEarnedValue: hasCreditsEarned ? creditsEarnedValue : 0,
          compositeScore: course?.CompositeScore,
          grade: course?.LetterGrade,
          CourseConnectionId: course?.CourseConnectionId
          };
        });

        const creditsEarned = courses.reduce((sum: number, c: any) => sum + (c.creditsEarnedValue || 0), 0);
        const creditsTotal = courses.reduce((sum: number, c: any) => sum + (c.credits || 0), 0);

        return {
          Semester: item?.Semester ?? index + 1,
          Gpa: typeof item?.GPA === "number" ? item?.GPA : Number(item?.GPA) || null,
          creditsEarned,
          creditsTotal,
          Courses: courses
        };
      });

      setSemestersData(semesters);
      setSelection(semesters);

      const initialSemester = semesters[0]?.Semester ?? 1;
      setActiveSemester(initialSemester);
      setTableData(semesters[0]?.Courses || []);
      console.log(semesters, "marks breakdown response");


    }).catch((err) => {
      console.error("Error in fetching marks breakdown:", err);
    }).finally(() => setLoading(false))
  }, []);

  const handleOpenModal = (row: any) => {
    console.log(row, "sdjnfskf");

    setSelectedRow(row);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedRow(null);
  };

  useEffect(() => {
    const current = semestersData.find((sem) => sem.Semester === activeSemester);
    if (current) {
      setTableData(current.Courses || []);
    }
  }, [activeSemester, semestersData]);


  // const handleChange = (event: any) => {
  //   setAge(event.target.value as any);
  // };


  const columns = [
    { field: "courseName", headerName: "Course name" },
    { field: "courseCode", headerName: "Course code" },
    { field: "credits", headerName: "Credits" },
    { field: "creditsEarned", headerName: "Credits earned" },
    { field: "compositeScore", headerName: "Composite score" },
    {
      field: "grade",
      headerName: "Grade",
      renderCell: ({ value }: any) => (
        <span
          style={{
            fontWeight: 600,
            color: value === "F" ? "red" : "#000",
          }}
        >
          {value}
        </span>
      ),
    },
    {
      field: "marksBreakdown",
      headerName: "Marks breakdown",
      renderCell: ({ row }: any) => (
        <IconButton size="small" >
          <VisibilityIcon onClick={() => handleOpenModal(row)} />
        </IconButton>
      ),
    },
  ];

  const renderMobileCards = () => (
    <Box display="flex" flexDirection="column" gap={2}>
      {tableData.map((row) => (
        <Box
          key={row.id}
          sx={{
            borderRadius: "16px",
            border: "1px solid #E2E8F0",
            backgroundColor: "#F6F8FB",
            padding: 2,
            boxShadow: "0px 2px 8px rgba(15, 23, 42, 0.06)",
          }}
        >
          <Typography fontWeight={600} fontSize={16}>
            {row.courseName}
          </Typography>
          <Typography fontSize={13} color="text.secondary" mt={0.3}>
            {row.courseCode}
          </Typography>

          <Box display="flex" justifyContent="space-between" mt={2}>
            <Box>
              <Typography fontSize={13} color="text.secondary">
                Credits:
              </Typography>
              <Typography fontSize={13} fontWeight={500}>
                {row.credits}
              </Typography>
            </Box>
            <Box textAlign="right">
              <Typography fontSize={13} color="text.secondary">
                Credits earned:
              </Typography>
              <Typography fontSize={13} fontWeight={500}>
                {row.creditsEarned}
              </Typography>
            </Box>
          </Box>

          <Box display="flex" justifyContent="space-between" mt={1.5}>
            <Box>
              <Typography fontSize={13} color="text.secondary">
                Composite score:
              </Typography>
              <Typography fontSize={13} fontWeight={500}>
                {row.compositeScore}
              </Typography>
            </Box>
            <Box textAlign="right">
              <Typography fontSize={13} color="text.secondary">
                Grade:
              </Typography>
              <Typography
                fontSize={13}
                fontWeight={700}
                sx={{ color: row.grade === "F" ? "#D14343" : "#1F2937" }}
              >
                {row.grade}
              </Typography>
            </Box>
          </Box>

          <Divider sx={{ my: 2 }} />
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            onClick={() => handleOpenModal(row)}
            sx={{ cursor: "pointer" }}
          >
            <Typography fontWeight={600} fontSize={14}>
              Marks breakdown
            </Typography>
            <ArrowForwardIcon fontSize="small" />
          </Box>
        </Box>
      ))}
    </Box>
  );


  const CustomTooltip = ({ active, payload }: any) => {
    if (active && payload && payload.length) {
      const gpaPoint = payload.find((p: any) => p.dataKey === "gpa");
      return (
        <Box
          sx={{
            background: "#fff",
            border: "1px solid #ddd",
            borderRadius: "8px",
            px: 1.5,
            py: 1,
            boxShadow: 2,
          }}
        >
          <Typography variant="body2" sx={{ fontWeight: 600, mb: 0.5 }}>
            {payload[0]?.payload?.semLabel}
          </Typography>
          {gpaPoint ? (
            <Typography variant="body2">GPA: {gpaPoint.value ?? "--"}</Typography>
          ) : null}
        </Box>
      );
    }
    return null;
  };

  const chartData = useMemo(
    () =>
      [...semestersData]
        .sort((a, b) => Number(a?.Semester ?? 0) - Number(b?.Semester ?? 0))
        .map((sem) => ({
          semLabel: `Sem ${sem.Semester}`,
          gpa: sem.Gpa ?? null,
        })),
    [semestersData]
  );

  const currentSemesterData = useMemo(
    () => semestersData.find((sem) => sem.Semester === activeSemester),
    [activeSemester, semestersData]
  );

  const totalCreditsEarned = useMemo(
    () => semestersData.reduce((sum, sem) => sum + (sem.creditsEarned || 0), 0),
    [semestersData]
  );

  const totalCreditsAvailable = useMemo(
    () => semestersData.reduce((sum, sem) => sum + (sem.creditsTotal || 0), 0),
    [semestersData]
  );

  const weightedCgpa = useMemo(() => {
    const numerator = semestersData.reduce((sum, sem) => {
      if (!sem.Gpa || Number.isNaN(sem.Gpa)) return sum;
      return sum + sem.Gpa * (sem.creditsEarned || 0);
    }, 0);
    const denominator = semestersData.reduce((sum, sem) => sum + (sem.creditsEarned || 0), 0);
    if (denominator === 0) return null;
    return Number((numerator / denominator).toFixed(2));
  }, [semestersData]);

  const renderDesktopSkeleton = () => (
    <Box>
      <Header title='Result' />
      <Box className={classes.container} sx={{ p: 3 }}>
        <Skeleton variant="text" width={200} height={28} />
        <Grid container spacing={2} mt={1}>
          <Grid size={{ md: 9, sm: 12, xs: 12 }} component={Paper} sx={{ p: 2 }}>
            <Skeleton variant="text" width="40%" height={26} />
            <Box display="flex" gap={2} mt={1} mb={2}>
              <Skeleton variant="rectangular" width={180} height={40} sx={{ borderRadius: 1 }} />
              <Skeleton variant="rectangular" width={140} height={40} sx={{ borderRadius: 1 }} />
            </Box>
            <Skeleton variant="rectangular" height={220} sx={{ borderRadius: 2 }} />
          </Grid>
          <Grid size={{ md: 3, sm: 12, xs: 12 }} component={Paper} sx={{ p: 2 }}>
            <Skeleton variant="text" width="70%" height={24} />
            <Skeleton variant="rectangular" height={180} sx={{ borderRadius: 2, mt: 1 }} />
            <Skeleton variant="rectangular" height={36} sx={{ borderRadius: 2, mt: 2 }} />
          </Grid>
        </Grid>
        <Box component={Paper} className='mt-4' sx={{ p: 2 }}>
          <Skeleton variant="text" width="30%" height={24} />
          <Skeleton variant="rectangular" height={180} sx={{ borderRadius: 2, mt: 2 }} />
        </Box>
      </Box>
    </Box>
  );

  const renderMobileSkeleton = () => (
    <Box>
      <Header title='Result' />
      <Box className={classes.containermobile} sx={{ p: 2 }}>
        <Skeleton variant="text" width={140} height={26} />
        <Skeleton variant="rectangular" height={180} sx={{ borderRadius: 2, mt: 2 }} />
        <Skeleton variant="text" width={120} height={22} sx={{ mt: 2 }} />
        <Skeleton variant="rectangular" height={160} sx={{ borderRadius: 2, mt: 1 }} />
      </Box>
    </Box>
  );

  if (loading) {
    return isMobile ? renderMobileSkeleton() : renderDesktopSkeleton();
  }


  return (
    <Box>
      <Header title='Result' />

      <Box className={isMobile ? classes.containermobile : classes.container}>
        <Grid container spacing={2}>
          <Grid size={{ md: 9, sm: 12, xs: 12 }} component={Paper}>
            <Box className="d-flex justify-content-between align-items-start" sx={{ flexDirection: isMobile ? 'column' : 'row', alignItems: isMobile ? 'flex-start' : 'center', gap: isMobile ? 1.5 : 0 }}>
              <Typography
                variant="subtitle1"
                sx={{ fontWeight: 500, color: "#333" }}
              >
                Semester breakup
              </Typography>
              <Box sx={{ display: "flex", gap: 2, width: isMobile ? '100%' : 'auto', mt: isMobile ? 1 : 0 }}>
                <Box
                  sx={{
                    border: "1px solid #B2B3B7",
                    borderRadius: "8px",
                    background: '#F6F8FB',
                    px: 1,
                    py: 1,
                    fontSize: isMobile ? 12 : 14,
                    width: isMobile ? 'fit-content' : 'auto',
                  }}
                >
                  Total credits earned:{" "}
                  <Typography sx={{ fontSize: isMobile ? 12 : 14 }} component="span" fontWeight={600}>
                    {totalCreditsEarned ?? 0}
                  </Typography>
                  /{totalCreditsAvailable ?? "--"}
                </Box>
                <Box
                  sx={{
                    border: "1px solid #B2B3B7",
                    background: '#F6F8FB',
                    borderRadius: "8px",
                    px: 1,
                    py: 1,
                    fontSize: isMobile ? 12 : 14,
                    width: isMobile ? 'fit-content' : 'auto',
                  }}
                >
                  CGPA:{" "}
                  <Typography sx={{ fontSize: isMobile ? 12 : 14 }} component="span" fontWeight={600}>
                    {weightedCgpa ?? "--"}
                  </Typography>
                </Box>
              </Box>
            </Box>


            {/* Chart */}
            <ResponsiveContainer width="100%" style={{ marginLeft: isMobile ? '-35px' : '', marginTop: isMobile ? '10px' : '' }} height={isMobile ? 240 : 260} className="mt-4">
              <LineChart data={chartData}>
                <CartesianGrid strokeDasharray="3 3" vertical={false} />
                <XAxis dataKey="semLabel" axisLine={false} tickLine={false} />
                <YAxis domain={[0, 10]} axisLine={false} tickLine={false} label={{ value: "GPA", angle: -90, position: "insideLeft", offset: 10 }} />
                <Tooltip content={<CustomTooltip />} cursor={{ stroke: "rgba(0,0,0,0.1)", strokeWidth: 1 }} />
                <Line
                  type="monotone"
                  dataKey="gpa"
                  stroke="#4caf50"
                  strokeWidth={2}
                  dot={{ r: 5, fill: "#4caf50" }}
                  activeDot={{ r: 7 }}
                  connectNulls
                />
              </LineChart>
            </ResponsiveContainer>

            {/* Footer summary */}

          </Grid>

          <Grid size={{ md: 3, sm: 12, xs: 12 }} >
            {
              isMobile ? <>
                <Box className='d-flex align-items-center p-3 mx-3' sx={{ background: "#523E5D", borderRadius: '8px' }}>
                  <Box>
                    <img src={semesterImagemobile} alt='semesterImage' style={{ width: isMobile ? '100%' : 'auto', maxWidth: '260px' }} />
                  </Box>
                  <Box sx={{ ml: 5 }}>
                    <Typography color='background.paper' className='fw-bold'>Semesters Grade Cards</Typography>
                    <Box className="bg-light rounded-5 px-3 py-1 mt-2 w-100 text-center" onClick={() => navigate("/student/gradeCard")}><Typography sx={{ fontSize: '12px', cursor:'pointer' }}>View all grade cards&nbsp; <span ><ArrowForwardIcon /></span></Typography></Box>
                  </Box>

                </Box></> : <Box component={Paper} padding={isMobile ? "16px" : "24px"} height={"100%"} display={"flex"} flexDirection={"column"} justifyContent={"space-between"} alignItems={"center"} sx={{ background: "#523E5D" }}>
                <Typography color='background.paper' className='fw-bold'>Semesters Grade Cards</Typography>
                <img src={semesterImage} alt='semesterImage' style={{ width: isMobile ? '100%' : 'auto', maxWidth: '260px' }} />
                <Box className="bg-light rounded-5 px-3 py-1 w-100 text-center" onClick={() => navigate("/student/gradeCard")}><Typography sx={{ fontSize: '14px', cursor:'pointer' }}>View all grade cards&nbsp; <span ><ArrowForwardIcon /></span></Typography></Box>
              </Box>
            }


          </Grid>
        </Grid>
        <Box component={Paper} className='mt-4' sx={{ p: isMobile ? 1.5 : 2 }}>
          {isMobile ? (
            <>
              <Box className="d-flex justify-content-between align-items-center">
                <Typography
                  variant="subtitle1"
                  sx={{ fontWeight: 500, color: "#333" }}
                >
                  Marks breakdown
                </Typography>
                <Button sx={{ height: "40px !important", borderRadius: '12px', }} onClick={() => navigate("/student/marksBreakdown")} variant='secondary'>View all</Button>
              </Box>

              <Box className='mt-2'>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={activeSemester}
                  onChange={handleChange}
                  displayEmpty
                  fullWidth
                  inputProps={{ 'aria-label': 'Without label' }}
                  sx={{
                    height: '48px',
                    width: '100%',
                    borderRadius: '12px',
                    '& .MuiOutlinedInput-notchedOutline': { borderColor: '#B2B3B7' },
                    '& .MuiSelect-select': { padding: '12px 14px' }
                  }}
                >
                  {selection.map((sem: any) => (
                    <MenuItem key={sem.Semester} value={sem.Semester}>
                      Semester {sem.Semester}
                      {activeSemester === sem.Semester && (
                        <Chip
                          label="Active semester"
                          sx={{
                            ml: 1,
                            borderRadius: "16px",
                            background: "#C7B7D1",
                            color: "#373A45",
                            fontSize: '12px',
                            padding: '4px !important'
                          }}
                        />
                      )}
                    </MenuItem>
                  ))}
                </Select>

              </Box>

              <Box className='mt-3' sx={{
                border: '1px solid #B2B3B7',
                background: '#F6F8FB',
                borderRadius: '12px',
                px: 2,
                py: 1.5,
                fontSize: 16,
                display: 'flex',
                justifyContent: 'center'
              }}>
                <Typography sx={{ fontSize: 16 }}>Credits earned : <Typography component="span" fontWeight={700} sx={{ fontSize: 16 }}>{currentSemesterData?.creditsEarned ?? 0}</Typography>/{currentSemesterData?.creditsTotal ?? "--"}&nbsp;&nbsp;|&nbsp;&nbsp; GPA : <Typography component="span" fontWeight={700} sx={{ fontSize: 16 }}>{currentSemesterData?.Gpa ?? "--"}</Typography></Typography>
              </Box>
            </>
          ) : (
            <Box className="d-flex justify-content-between align-items-center " sx={{ flexDirection: 'row', alignItems: 'center' }}>
              <Typography
                variant="subtitle1"
                sx={{ fontWeight: 500, color: "#333" }}
              >
                Marks breakdown
              </Typography>
              <Box sx={{ display: "flex", gap: 2, alignItems: 'center' }}>
                <Box
                  sx={{
                    border: "1px solid #B2B3B7",
                    background: '#F6F8FB',
                    borderRadius: "8px",
                    px: 1,
                    py: 1,
                    fontSize: 14,
                    display: 'flex',
                    alignItems: 'center'
                  }}
                >
                  Credits earned :
                  <Typography sx={{ fontSize: 14 }} component="span" fontWeight={600}>
                    &nbsp;  {currentSemesterData?.creditsEarned ?? 0}/{currentSemesterData?.creditsTotal ?? "--"}
                  </Typography> &nbsp; | &nbsp;  GPA:{" "}
                  <Typography sx={{ fontSize: 14 }} component="span" fontWeight={600}>
                    &nbsp;{currentSemesterData?.Gpa ?? "--"}
                  </Typography>
                </Box>

                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={activeSemester}
                  onChange={handleChange}
                  displayEmpty
                  fullWidth
                  inputProps={{ 'aria-label': 'Without label' }}
                  sx={{
                    height: '42px',
                    width: '300px', '& .MuiSelect-select': {
                      padding: '10px 14px',
                    },
                  }}
                >
                  {selection.map((sem: any) => (
                    <MenuItem key={sem.Semester} value={sem.Semester}>
                      Semester {sem.Semester}
                      {activeSemester === sem.Semester && (
                        <Chip
                          label="Active semester"
                          sx={{
                            ml: 1,
                            borderRadius: "16px",
                            background: "#C7B7D1",
                            color: "#373A45",
                            fontSize: '12px',
                            padding: '4px !important'
                          }}
                        />
                      )}
                    </MenuItem>
                  ))}
                </Select>

                <Button sx={{ height: "40px !important" }} onClick={() => navigate("/student/marksBreakdown")} variant='secondary'>View all</Button>
              </Box>
            </Box>
          )}
          <Box className="mt-4">
            {isMobile ? (
              renderMobileCards()
            ) : (
              <KenTable
                columns={columns}
                rows={tableData}
                showCheckbox={false}
              />
            )}
          </Box>
          <Dialog PaperProps={{
            sx: {
              padding: '0px',
              width: isMobile ? '100%' : '80%',
              maxWidth: 'none'
            },
          }} open={open} onClose={handleClose} maxWidth="sm" fullWidth fullScreen={isMobile}>
            <DialogTitle>
              <Box className="d-flex justify-content-between align-items-center">
                <Typography sx={{ fontSize: '20px', fontWeight: 700 }}> Marks Breakdown</Typography>
                <Box ><CloseIcon onClick={() => handleClose()} /></Box>
              </Box>
            </DialogTitle>
            <DialogContent>
              <NetworkAnalysis data={selectedRow} />
            </DialogContent>
          </Dialog>
        </Box>
      </Box>
    </Box>
  );
};

export default Dashboard;
